import React, { useState, useEffect } from 'react';
import styles from './MeasureToolContainer.module.scss';
import { MEASURE_TOOL_ALL_LINES } from '../../constants/constants';

export const LineList = ({ selectedLine, selectLine }) => {
  const [allLines, setAllLines] = useState();
  useEffect(() => {
    const allLineData = [];
    for (let i = 0; i < MEASURE_TOOL_ALL_LINES; i++) {
      const currentNum = i + 1;
      allLineData.push({
        name: 'Line-' + currentNum,
        value: currentNum,
      });
    }
    setAllLines([...allLineData]);
  }, []);
  // style={{ right: heightWidth?.width - 150 }}
  return (
    <div className={styles.lineList}>
      {!!allLines?.length &&
        allLines?.map((lineData, index) => {
          const styleObj = {
            borderTop: lineData.value + 'px solid #fff',
          };
          return (
            <div key={index} className={`${styles.lineConatiner} ${
                lineData.name === selectedLine.name ? styles.lineSelected : ''
              }`}
              onClick={() => selectLine(lineData)}>
              <hr
                style={styleObj}
                className={styles.lineCard}
              />
            </div>
          );
        })}
    </div>
  );
};
